import { types as coreTypes } from '@sitebuilder/core';

export class QueryApiClient implements coreTypes.IGraphQLClient {
    baseUrl: string;
    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    private async fetchGraphQL(
        url: string,
        bodyParams: any,
        authorizationToken?: string,
        isDownload?: boolean
    ) {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(authorizationToken ? { Authorization: `bearer ${authorizationToken}` } : {}),
            },
            body: JSON.stringify(bodyParams),
        });
        if (!response.ok) {
            const body = await response.text();
            if (isDownload) {
                throw new Error(body);
            } else {
                throw new Error(
                    `Invalid response from GraphQL server: Status: ${response.status}\n${body}`
                );
            }
        }

        const resp = isDownload ? await response.text() : await response.json();

        return resp;
    }

    async executeQuery<T extends coreTypes.GraphQLQueryResult>(
        params: coreTypes.GraphQLQueryParams
    ): Promise<T> {
        const {
            dataSetName,
            authorizationToken,
            query,
            variables,
            extensions,
            baseUrl,
        } = params;

        const url = new URL(
            `/api/graphql/${dataSetName}`,
            this.baseUrl || baseUrl || window.location.origin
        ).href;

        const bodyParams = { query, variables, extensions };

        const data = await this.fetchGraphQL(url, bodyParams, authorizationToken);

        if (!data.data && data.errors && data.errors.length > 0) {
            throw new Error(JSON.stringify(data));
        }

        return data;
    }

    async downloadWithQuery<T extends coreTypes.GraphQLQueryResult>(
        params: coreTypes.DownloadWithGraphQLQueryParams
    ): Promise<T> {
        const {
            dataSetName,
            authorizationToken,
            query,
            variables,
            extensions,
            baseUrl,
            fileName,
            documentName,
            columns,
            transformFunction,
            componentName,
        } = params;

        const url = new URL(
            `/api/graphql/download/${dataSetName}`,
            this.baseUrl || baseUrl || window.location.origin
        ).href;

        const bodyParams = {
            query,
            variables,
            extensions,
            fileName,
            documentName,
            columns,
            transformFunction,
            componentName,
        };

        const data = await this.fetchGraphQL(
            url,
            bodyParams,
            authorizationToken,
            true
        );

        return data;
    }
}
